interface ArtistNameplateProps {
  className?: string
  compact?: boolean
  context?: string
}

export function ArtistNameplate({ className = '', compact = false, context }: ArtistNameplateProps) {
  return (
    <span className={`artist-nameplate ${compact ? 'artist-nameplate--compact' : ''} ${className}`.trim()}>
      <b className="artist-nameplate__artist">THE PARADOX</b>
      {context ? <small className="artist-nameplate__context">{context}</small> : null}
    </span>
  )
}

